import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { BancoNoticiasOutputDto } from "src/app/domain/DTOs/output/banco-noticias.output.dto";
import { obterBancoNoticias, obterBancoNoticiasSuccess, obterBancoNoticiasFailure, obterBancoNoticiasFinish } from "../../actions/BancoNoticias/obter-banco-noticias.action";

export interface ObterBancoNoticiasState {
  response: EstruturaRetornoDadosOutputDto<BancoNoticiasOutputDto[]> | null;
  error: string[] | null;
}

export const initialState: ObterBancoNoticiasState = {
  response: null,
  error: null,
};

export const ObterBancoNoticiasReducer = createReducer(
  initialState,
  on(obterBancoNoticias, state => ({ ...state, error: null })),
  on(obterBancoNoticiasSuccess, (state, { response }) => ({ ...state, response, error: null })),
  on(obterBancoNoticiasFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
  on(obterBancoNoticiasFinish, state => ({ ...state, response: null, error: null }))
);
